import { IListDto } from "../../../../interface/dto/list.dto";
import {
    IListToTrackActions,
    ListToTrackSearchActionTypes,
} from "./list-to-track.actions";

export interface IListToTrackState {
    isLoading: boolean;
    lists: Array<IListDto>;
    selectedList?: IListDto;
    error?: string;
}

const initTrackList: IListToTrackState = {
    isLoading: false,
    lists: [],
    selectedList: undefined,
    error: undefined,
};

export const listToTrackReducer = (
    state = initTrackList,
    action: IListToTrackActions,
): IListToTrackState => {
    switch (action.type) {
        case ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET:
            return {
                ...state,
                isLoading: true,
                error: undefined,
                lists: [],
            };
        case ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET_ERROR:
            return { ...state, error: action.payload.error, isLoading: false };
        case ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET_SUCCESS:
            return { ...state, lists: action.payload.lists, isLoading: false };
        case ListToTrackSearchActionTypes.LIST_TO_TRACK_SELECT:
            return { ...state, selectedList: action.payload.selectedList };
        default:
            return state;
    }
};
